import { useMemo } from "react";
import { useHprService } from "../../context/HprServiceContext";
import { HprCacheKeys } from "../cacheKeys";
import { IHprSettings } from "../../models/IHprSettings";
import useSWR from "swr";

export type IUseHprSettingsHook = () => {
    data: IHprSettings | null;
    fetching: boolean;
};

export const useHprSettings: IUseHprSettingsHook = () => {

    const service = useHprService();
    const token = service.getToken();

    const fetcher = async (): Promise<IHprSettings> => {
        const settingsData = await service.getHprSettings();
        if (settingsData.isFailure) {
            throw settingsData.error;
        }
        return settingsData.value;
    };

    const { data, isValidating } = useSWR(() =>
        [HprCacheKeys.HprSettings, token],
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: false,
            revalidateOnMount: false
        }
    );

    const rawData = data || null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);

};